// extracted by mini-css-extract-plugin
export default {"isFirst":"wildcard-icon_isFirst__PvCAO","isSecond":"wildcard-icon_isSecond__4qR3J","wildcard":"wildcard-icon_wildcard__3269E","wildcardRibbon":"wildcard-icon_wildcardRibbon__hlelk"};